import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {showError, showSuccess, showInfo} from "../components/Utils/toastUtils"
import { PageModal, customStyles } from "../components/Utils/CustomStyles";
import { estaAbiertaMaiquetia } from "../components/Utils/horariosSucursal";
import imgNav from "../img/Logotipo.webp"
import { FaLocationArrow } from "react-icons/fa";
import BotonVolver from "../components/BotonVolver";
import { motion, AnimatePresence } from "framer-motion";

// 💰 Tarifas normales (desde Maiquetía)
const tarifasMaiquetia = {
  "Maiquetia": "1.00",
  "La Guaira": "2.50",
  "Guanape": "2.50",
  "Canaima": "2.00",
  "Pariata": "1.00",
  "10 de Marzo": "1.00",
  "El Trébol": "1.00",
  "Montesano": "1.00",
  "Punta de Mulatos": "3.00",
  "Mare Abajo": "3.00",
  "La Aviación": "2.00",
  "Sotavento ": "2.00",
  "Santa Eduviges": "2.00",
  "Barrio Aeropuerto ": "2.00",
  "Aeropuerto IAIM": "2.50",
  "Playa Verde": "3.00",
  "Playa Grande": "3.00",
  "Guaracarumbo ": "3.00",
  "La Lucha": "3.00",
  "Zamora": "3.00",
  "Catia la mar": "3.00",
  "La Soublette": "4.00",
  "Soublette negro Primero": "5.00",
  "Marapa Mariana ": "4.00",
  "Catanare ": "4.00",
  "María Piache": "4.50",
  "Las Tunitas": "5.00",
  
  
  

};

// 💰 Tarifas invertidas (desde Caraballeda)
const tarifasCaraballeda = {
  "Corales": "1.00",
  "Caraballeda": "2.00",
  "Caribe": "2.00",
  "Urbanizacion la Llanada": "2.00",
  "Valle El Pino": "2.00",
  "Macuto": "3.00",
  "Tanaguarenas": "3.00",
  "San Julian": "3.00",
  "La Guaira": "4.00",
  "Maiquetia": "4.00",
  "Pariata": "5.00",
  "Carlos Soublette": "5.00",
  "Aviación": "2.00",
  "Aeropuerto IAIM": "6.00",
  "Catia la mar": "6.00",
  "Naiguata": "6.00",

};


// 📞 Teléfonos por sucursal
const telefonosPorSucursal = {
  Maiquetia: "+584122905789",
  Caraballeda: "+584122905789",
};


const PedidoForm = () => {
  const [nombre, setNombre] = useState("");
  const [zonaSeleccionada, setZonaSeleccionada] = useState("");
  const [sector, setSector] = useState("");
  const [telefono, setTelefono] = useState("");
  const [comentarios, setComentarios] = useState("");
  const [entrega, setEntrega] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [tarifa, setTarifa] = useState(null);
  const [ready, setReady] = useState(false); // ← evita sobrescribir con vacíos
  const [tarifasBase, setTarifasBase] = useState(tarifasMaiquetia);
  const [ubicacionObtenida, setUbicacionObtenida] = useState(false);
  const [sucursal, setSucursal] = useState("");
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showUbicacionModal, setShowUbicacionModal] = useState(false);
  const [datosTemporales, setDatosTemporales] = useState(null);

  useEffect(() => {
    const raw = localStorage.getItem("datosPedido");
    if (raw) {
      const d = JSON.parse(raw);
      if (d?.nombre || d?.telefono) {
        setDatosTemporales(d);
        setShowRecoverModal(true);
      }
    }
  }, []);

  const handleAceptarRecuperar = () => {
    if (datosTemporales) {
      setNombre(datosTemporales.nombre || "");
      setTelefono(datosTemporales.telefono || "");
      setComentarios(datosTemporales.comentarios || "");
      setEntrega(datosTemporales.entrega || "");
      setSucursal(datosTemporales.sucursal || "");
      setUbicacionObtenida(!!datosTemporales.ubicacionURL);

      if (datosTemporales.sucursal) {
        setTarifasBase(
          datosTemporales.sucursal === "Maiquetia"
            ? tarifasMaiquetia
            : tarifasCaraballeda
        );
      }

      if (datosTemporales.zonaSeleccionada && datosTemporales.entrega === "Delivery") {
        const parts = datosTemporales.zonaSeleccionada.split(",");
        const zona = (parts[0] || "").trim();
        const sectorRecuperado = (parts[1] || "").trim();
        setZonaSeleccionada(zona);
        setSector(sectorRecuperado);
        setTarifa(datosTemporales.tarifaDelivery);
      } else {
        setZonaSeleccionada(datosTemporales.zonaSeleccionada || "");
        setSector(datosTemporales.direccion || "");
      }
      showSuccess("Datos recuperados correctamente");
    }
    setShowRecoverModal(false);
  };

  const handleRechazarRecuperar = () => {
    setNombre("");
    setTelefono("");
    setComentarios("");
    setEntrega("");
    setSucursal("");
    setZonaSeleccionada("");
    setSector("");
    setTarifa(null);
    setUbicacionObtenida(false);
    localStorage.removeItem("datosPedido");
    setShowRecoverModal(false);
  };

  const navigate = useNavigate();

  // ⏰ Validación de horarios para Pariata / Maiquetía
  // (viernes desde 11:00 am; resto desde 4:00 pm; viernes a domingo hasta medianoche)
const estaHabilitadaMaiquetia = () => estaAbiertaMaiquetia();


const obtenerUbicacion = () => {
  if (!navigator.geolocation) {
    showError("La geolocalización no está soportada en este dispositivo.");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const lat = pos.coords.latitude;
      const lng = pos.coords.longitude;

      // URL para google maps
      const urlMapa = `https://www.google.com/maps?q=${lat},${lng}`;

      // Guardar en localStorage
      const raw = localStorage.getItem("datosPedido");
      const datosPrevios = raw ? JSON.parse(raw) : {};

      const nuevosDatos = {
        ...datosPrevios,
        ubicacionURL: urlMapa,
        latitud: lat,
        longitud: lng,
      };

      localStorage.setItem("datosPedido", JSON.stringify(nuevosDatos));

      // Guardar en estado
      setUbicacionObtenida(true);

      showSuccess(`Ubicación guardada correctamente.`);
    },
    () => {
      showError("No se pudo obtener tu ubicación.");
    }
  );
};



  const handleSucursalChange = (sucursalElegida) => {
    if (sucursalElegida === sucursal) return; // ← No borrar si ya está seleccionada

    if (sucursalElegida === "Maiquetia" && !estaHabilitadaMaiquetia()) {
      showError("La sucursal Maiquetía está inhabilitada en este horario.");
      return;
    }

    setSucursal(sucursalElegida);
    setZonaSeleccionada("");
    setSector("");
    setTarifa(null);
    setEntrega("");

    // ACTUALIZAR LOCALSTORAGE AL CAMBIAR
    const raw = localStorage.getItem("datosPedido");
    const datosPrevios = raw ? JSON.parse(raw) : {};
    localStorage.setItem("datosPedido", JSON.stringify({
      ...datosPrevios,
      sucursal: sucursalElegida
    }));

    // TELÉFONO
    const telefonoSucursal = telefonosPorSucursal[sucursalElegida] || null;
    localStorage.setItem("telefonoSucursal", telefonoSucursal);

  // TARIFAS
  setTarifasBase(
    sucursalElegida === "Maiquetia"
      ? tarifasMaiquetia
      : tarifasCaraballeda
  );
};

const finalizarPedido = () => {
  const direccionFinal =
    entrega === "Delivery"
      ? `${zonaSeleccionada}, ${sector.trim()}`
      : sucursal === "Maiquetia"
        ? "Pariata, Maiquetia (Sucursal)"
        : "Los Corales, Caraballeda (Sucursal)";

  const zonaFormateada =
    entrega === "Delivery"
      ? `${zonaSeleccionada}, ${sector.trim()}`
      : "Retiro en Sucursal";

  const raw = localStorage.getItem("datosPedido");
  const datosPrevios = raw ? JSON.parse(raw) : {};

  const datosPedido = {
    nombre,
    telefono,
    comentarios,
    entrega,
    sucursal,
    zonaSeleccionada: zonaFormateada,
    direccion: direccionFinal,
    tarifaDelivery: entrega === "Delivery" && tarifa ? tarifa : 0,

    ubicacionURL: datosPrevios.ubicacionURL || null,
    latitud: datosPrevios.latitud || null,
    longitud: datosPrevios.longitud || null,
  };

  localStorage.setItem("datosPedido", JSON.stringify(datosPedido));

  setMostrarModal(true);
  setTimeout(() => {
    setMostrarModal(false);
    window.scrollTo(0, 0);
    navigate("/resumen");
  }, 2000);
};

  const handleSiguiente = () => {


    if (!nombre.trim() || !telefono.trim()) {
      showError("Por favor, completa todos los campos.");
      return;
    }

    if (!sucursal) {
      showError("Por favor, selecciona una sucursal.");
      return;
    }

    if (!entrega) {
      showError("Por favor, elige una forma de entrega.");
      return;
    }

    const telefonoLimpio = telefono.trim();
    const telefonoValido = /^(0412|0414|0424|0416|0426|0422)\d{7}$/.test(telefonoLimpio);
    if (!telefonoValido) {
      showError("El teléfono debe tener 11 dígitos y comenzar con un código válido.");
      return;
    }

    if (entrega === "Delivery") {   

      if (!sector.trim()) {
        showError("Por favor, escribe el sector.");
        return;
      }

       if (!zonaSeleccionada) {
        showError("Por favor, selecciona una zona.");
        return;
      }

      if (!ubicacionObtenida) {
        setShowUbicacionModal(true);
        return;
      }
    }

    finalizarPedido();
  };

 





 return (
  <div className="pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] min-h-screen flex justify-center px-4 py-4 mb-10">
    <div className="bg-white rounded-2xl w-full lg:w-[90%] max-w-5xl shadow-[0_0_25px_rgba(0,0,0,0.4)] relative mt-20 p-8">
      <div className="absolute top-4 left-4 z-20">
        <BotonVolver to="/" label="Inicio" />
      </div>

      {/* Logo */}
      <div className="flex justify-center -mt-20 mb-2">
        <img
          src={imgNav}
          alt="Logotipo Japan Food"
          className="w-32 sm:w-40 lg:w-48 object-contain drop-shadow-[0_0_10px_rgba(255,255,255,0.25)]"
        />
      </div>

      <p className="text-neutral-300 text-center mb-8 font-semibold -mt-16">
        Completá tus datos para realizar tu pedido.
      </p>

      {/* 🔸 SUCURSAL Y ENTREGA */}
      <div className="bg-white/70 rounded-2xl p-6 mb-10 border border-yellow-200 shadow-sm max-w-3xl mx-auto">
        <p className="text-yellow-600 font-bold mb-4 text-center">
          Sucursal y forma de entrega
        </p>

        {/* Sucursal */}
        <div className="flex justify-center gap-10 mb-4 flex-wrap text-gray-700">
          {["Maiquetia", "Caraballeda"].map((s) => (
            <label key={s} className="flex items-center gap-2 font-semibold">
              <input
                type="radio"
                name="sucursal"
                value={s}
                checked={sucursal === s}
                onChange={(e) => handleSucursalChange(e.target.value)}
                className="accent-yellow-500"
              />
              {s}
            </label>
          ))}
        </div>

        {/* Delivery o Retiro */}
        <div className="flex justify-center text-gray-700 gap-8 flex-wrap">
          {["Delivery", "Retiro"].map((m) => (
            <label key={m} className="flex items-center gap-2 font-semibold">
              <input
                type="radio"
                name="entrega"
                value={m}
                checked={entrega === m}
                onChange={() => setEntrega(m)}
                className="accent-yellow-500"
              />
              {m}
            </label>
          ))}
        </div>
      </div>

      {/* 🔹 FORMULARIO */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">

        {/* Nombre */}
        <input
          type="text"
          placeholder="Nombre"
          className="p-3 border border-gray-200 rounded-xl shadow-sm bg-transparent"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
        />

        {/* Teléfono */}
        <input
          type="tel"
          placeholder="Teléfono"
          className="p-3 border border-gray-200 rounded-xl shadow-sm bg-transparent"
          value={telefono}
          onChange={(e) => setTelefono(e.target.value.replace(/\D/g, ""))}
          maxLength={11}
        />

        {/* Tarifas Delivery (Select) */}
        {entrega === "Delivery" && sucursal && (
          <div className="md:col-span-2 space-y-2">
            <label className="text-gray-600 font-semibold text-sm">Zona de Delivery:</label>
            <Select
              options={Object.entries(tarifasBase).map(([z, t]) => ({
                label: z,
                value: z,
                tarifa: parseFloat(t)
              }))}
              styles={customStyles}
              placeholder="Escribe para buscar tu zona..."
              noOptionsMessage={() => "No se encontró la zona o sector"}
              value={zonaSeleccionada ? { label: zonaSeleccionada, value: zonaSeleccionada } : null}
              onChange={(sel) => {
                setZonaSeleccionada(sel.value);
                setTarifa(sel.tarifa);
              }}
            />
          </div>
        )}

        {/* RETIRO */}
        {entrega === "Retiro" && (
          <div className="md:col-span-2 bg-yellow-50 border border-yellow-300 rounded-xl p-4 text-yellow-600 font-semibold text-center">
            {sucursal === "Maiquetia"
              ? "Pariata, Maiquetia"
              : "Los Corales, Caraballeda"}
          </div>
        )}

        {/* DELIVERY */}
        {entrega === "Delivery" && (
          <>
            

            {/* Sector */}
            <input
              type="text"
              placeholder="Avenida, sector o calle"
              className="md:col-span-2 p-3 border border-gray-200 rounded-xl shadow-sm bg-transparent"
              value={sector}
              onChange={(e) => setSector(e.target.value)}
            />

            

                  <button
                    type="button"
                    onClick={obtenerUbicacion}
                    className={`p-3 rounded-xl font-bold shadow-sm flex items-center justify-center gap-2 transition-all duration-300 ${
                      ubicacionObtenida
                        ? "bg-green-100 text-green-600 border border-green-300"
                        : "bg-neutral-500 text-white"
                    }`}
                  >
                    <FaLocationArrow
                      className={`text-lg ${
                        ubicacionObtenida ? "text-green-600" : "text-white"
                      }`}
                    />
                    {ubicacionObtenida ? "Ubicación obtenida" : "Obtener ubicación"}
                  </button>



            {/* Tarifa calculada */}
            {tarifa !== null && (
              <div className="flex items-center justify-center bg-white border border-yellow-300 rounded-xl p-3 font-semibold text-yellow-600">
                Tarifa: ${tarifa}
              </div>
            )}
          </>
        )}
      </div>

      {/* ✏️ COMENTARIOS */}
      <div className="max-w-3xl mx-auto mt-8">
        <textarea
          placeholder="¿Hay algo que no quieras incluir en tu pedido?"
          className="w-full p-3 border border-gray-200 rounded-xl shadow-sm bg-transparent"
          value={comentarios}
          onChange={(e) => setComentarios(e.target.value)}
        />
      </div>

      {/* BOTÓN */}
      <button
        onClick={handleSiguiente}
        className="bg-yellow-500 font-extrabold text-white px-14 py-3 mt-8 rounded-xl mx-auto block"
      >
        Siguiente
      </button>
    </div>

    <AnimatePresence>
      {showRecoverModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleRechazarRecuperar}
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          />
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            className="relative bg-white rounded-3xl p-8 max-w-sm w-full text-center shadow-2xl border border-yellow-100"
          >
            <div className="flex justify-center mb-4">
              <div className="bg-yellow-100 p-4 rounded-full">
                <img src={imgNav} alt="Logo" className="w-16 h-16 object-contain" />
              </div>
            </div>
            
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              ¿Deseas recuperar tus datos?
            </h3>
            <p className="text-gray-500 mb-6 font-medium">
              Hemos encontrado información de tu última compra. ¿Deseas completarlos automáticamente?
            </p>
            
            <div className="flex gap-4">
              <button
                onClick={handleRechazarRecuperar}
                className="flex-1 py-3 px-4 bg-gray-100 text-gray-600 font-bold rounded-2xl hover:bg-gray-200 transition-colors"
              >
                No
              </button>
              <button
                onClick={handleAceptarRecuperar}
                className="flex-1 py-3 px-4 bg-yellow-400 text-white font-bold rounded-2xl"
              >
                Sí, recuperar
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>

    <AnimatePresence>
      {showUbicacionModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowUbicacionModal(false)}
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          />
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            className="relative bg-white rounded-3xl p-8 max-w-sm w-full text-center shadow-2xl border border-blue-100"
          >
            <div className="flex justify-center mb-4">
              <div className="bg-blue-100 p-4 rounded-full">
                <FaLocationArrow className="w-8 h-8 text-blue-500" />
              </div>
            </div>
            
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              ¿Continuar sin ubicación?
            </h3>
            <p className="text-gray-500 mb-6 font-medium">
              No hemos podido obtener tu ubicación GPS. Si continúas, recuerda que deberás <strong>compartir tu ubicación actual directamente por WhatsApp</strong> al finalizar el pedido.
            </p>
            
            <div className="flex flex-col gap-3">
              <button
                onClick={() => {
                  setShowUbicacionModal(false);
                  obtenerUbicacion();
                }}
                className="w-full py-3 px-4 bg-gray-100 text-gray-600 font-bold rounded-2xl hover:bg-gray-200 transition-colors"
              >
                Intentar obtener ubicación
              </button>
              <button
                onClick={() => {
                  setShowUbicacionModal(false);
                  finalizarPedido();
                }}
                className="w-full py-3 px-4 bg-blue-500 text-white font-bold rounded-2xl"
              >
                Sí, continuar y enviar por WhatsApp
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>

    <PageModal
      mostrarModal={mostrarModal}
      onComplete={() => setMostrarModal(false)}
    />
  </div>
);




};

export default PedidoForm;
